"use strict";

exports.__esModule = true;
var pick = function pick(obj, keys) {
  var result = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (obj.hasOwnProperty(key)) {
      result[key] = obj[key];
    }
  }
  return result;
};

exports.default = pick;


//////////////////
// WEBPACK FOOTER
// ./~/recompose/utils/pick.js
// module id = 174
// module chunks = 0